<script setup lang="ts">
/**
 * Homepage hero in "classic form" mode: no AI, the visitor fills the CV editor
 * section by section. The editor needs an account, so the button goes through
 * useStartCVForm (registration first for guests, then straight to /cv/new).
 */
const { t } = useI18n()
const { startCVForm } = useStartCVForm()

const points = [
  { id: 'sections', icon: 'bi-list-check' },
  { id: 'preview', icon: 'bi-eye' },
  { id: 'templates', icon: 'bi-palette' },
] as const
</script>

<template>
  <section class="sofax relative overflow-hidden bg-white dark:bg-gray-950">
    <div class="pb-12 pt-3 md:pb-16 md:pt-6 lg:pt-8">
      <div class="shell relative">
        <div class="mb-4 md:mb-6">
          <slot name="switcher" />
        </div>

        <div class="mx-auto max-w-5xl text-center">
          <h1 class="hero-mode-title">{{ t('cvModes.form.title') }}</h1>
          <p class="lead mx-auto max-w-3xl max-md:hidden">{{ t('cvModes.form.subtitle') }}</p>
        </div>

        <div class="mx-auto mt-3 max-w-[46rem] rounded-[0.625rem] border border-line bg-white p-5 text-left shadow-lift md:mt-6 md:p-8 dark:border-gray-700 dark:bg-gray-800">
          <ul class="space-y-4">
            <li v-for="point in points" :key="point.id" class="flex items-start gap-4">
              <SofaxIconTile :icon="point.icon" size="sm" />
              <div>
                <div class="font-semibold text-ink dark:text-white">{{ t(`cvModes.form.points.${point.id}.title`) }}</div>
                <p class="!text-base text-body dark:text-gray-300">{{ t(`cvModes.form.points.${point.id}.description`) }}</p>
              </div>
            </li>
          </ul>

          <div class="mt-6 flex flex-col items-center gap-3 border-t border-line pt-5 sm:flex-row sm:justify-between dark:border-gray-700">
            <LocaleLink to="/templates" class="link text-sm">
              {{ t('cvModes.form.templates') }}
            </LocaleLink>
            <SofaxBtn variant="accent" :label="t('cvModes.form.cta')" class="w-full sm:w-auto" @click="startCVForm()" />
          </div>
        </div>

        <p class="mx-auto mt-4 max-w-[46rem] text-center text-sm text-muted md:mt-6 dark:text-gray-400">
          <i class="bi bi-info-circle mr-1" />{{ t('cvModes.form.accountNote') }}
        </p>
      </div>
    </div>
  </section>
</template>
